export const graphSkin = (theme, _parameters) => {
  switch (theme.baseThemeName) {
    case 'dark':
      {
        return {
          skinGlowThickness: 2
        };
      }
    case 'high-contrast':
      {
        return {
          skinGlowThickness: 1
        };
      }
    default:
      {
        return {
          skinGlowThickness: 1
        };
      }
  }
};
//# sourceMappingURL=graphSkin.js.map